import { forwardRef, SVGProps } from "react";

// Three notes at different pitches inside a frame: the Text to vocals piano roll in miniature.
export const PianoRollIcon = forwardRef<
  SVGSVGElement,
  Omit<SVGProps<SVGSVGElement>, "ref"> & {
    title?: string | undefined;
    titleId?: string | undefined;
  }
>(({ className, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        x="2.5"
        y="2.5"
        width="15"
        height="15"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="4.25"
        y="12.25"
        width="3.75"
        height="1.5"
        rx="0.75"
        fill="currentColor"
      />
      <rect
        x="8.25"
        y="6.25"
        width="3.75"
        height="1.5"
        rx="0.75"
        fill="currentColor"
      />
      <rect
        x="12.25"
        y="9.25"
        width="3.75"
        height="1.5"
        rx="0.75"
        fill="currentColor"
      />
    </svg>
  );
});

PianoRollIcon.displayName = "PianoRollIcon";
